module.exports = __webpack_public_path__ + "img/vxingkuai1.prt.9060aa62.jpg";